import moment from "moment";

export const MAX_DATE_RANGE_IN_DAYS = 90;
export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_FORMAT_PRINT = "DD MMM YYYY";
export const DATE_FORMAT_CHART = "MMM-DD";
export const DATE_FORMAT_METRIC = "YYYYMMDD";
// Note: Always have to get new momentjs object to avoid self-calculated on imported date
// TODO: move to proper place
export const getAdminDefaultDateAvailableReport = () =>
  moment().subtract(2, "days");
export const getDefaultDateAvailableReport = () => moment().subtract(2, "days");
export const DEFAULT_CONTENT_DATE_AVAILABLE_REPORT_DAYS = 8;
export const getDefaultContentDateAvailableReport = () =>
  moment().subtract(DEFAULT_CONTENT_DATE_AVAILABLE_REPORT_DAYS, "days");
